<template>
  <div>
    <section class="course-area course-area4">
    <div class="course-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="course-tab-wrap d-flex align-items-center" style="    margin-top: 20px;">
                     <img src="/static/images/icon_cuoti.png" class="courses-showing-icon"/><span class="courses-showing-text">共有{{intTotal}}道错题记录</span>
                    </div><!-- end course-tab-wrap -->
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-wrapper -->
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab2">
                            <div class="row course-block course-list-block">
                                <div class="col-lg-12" v-for="(qust,index) in errQusts" :key="index">
                                    <div class="course-item">
                                        <div class="course-content" style="width: 100%;border-left:1px solid rgba(127, 136, 151, 0.2);">
                                            <p class="course__label">
                                                <el-tag type="success" style="margin-right:11px">题型：{{qust.questiontype}}</el-tag>
                                                 <el-tag type="success">科目：{{getQustInfo(qust).type}}</el-tag>
                                            </p>
                                            <div class="test_printcontent_nr_tt" v-if="qust.questiontype!='复合题'">
                                                <font style="color: #000;"><i class="el-icon-star-on" style="color: #FF8600FF;"></i>&nbsp;&nbsp;{{getQustInfo(qust).title}}</font>
                                                <br v-if="qust.filepath"/> <img v-if="qust.filepath" :src="`${global.remoteIp}/uploads/${qust.filepath}`" alt="" style="width: 60%;">
                                                <br v-if="qust.filepath"/><br v-if="qust.filepath"/>
                                            </div>
                                            <div class="test_printcontent_nr_tt" v-else>
                                                <font style="color: #000;"><i class="el-icon-star-on" style="color: #FF8600FF;"></i>&nbsp;&nbsp;<p v-html="getQustInfo(qust).title"></p></font>
                                            </div>
                                            <div class="test_printcontent_nr_main" style="margin-left: 3px; margin-top: 5px;">
                                                <ul v-if="getQustInfo(qust).foption">
                                                    <li v-for="(option,indexex) in getQustInfo(qust).foption.split(',jh,')" :key="indexex" style=" display:inline;margin-right: 25px">
                                                        <label style="font-weight:500">
                                                            {{option.slice(0,2)}}
                                                            <p  style="display: inline;">{{option.slice(2)}}</p>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div >
                                                <span class="text-info mb-1 " v-if="getQustInfo(qust).level">[ 题目难度：{{getQustInfo(qust).level}} ]</span>
                                                
                                            </div>
                                            <div style="line-height: 23px;">
                                                <!-- <span class="text-success mb-1 " v-if="qust.correctanswer">[ 正确答案：{{qust.correctanswer}} ]</span> -->
                                                <span class="text-danger mb-1 mb-1" >[ 你的答案：{{qust.useranswer}} ]</span>
                                            </div>
                                            <!-- <div >
                                                <template><span class="text-primary mb-1" >[ 答案解析：{{getQustInfo(qust).remarks}} ]</span></template>
                                            </div> -->
                                        </div><!-- end course-content -->
                                    </div><!-- end course-item -->
                                </div><!-- end col-lg-12 -->
                            </div>
                        </div>
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                           <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        global,
        intTotal:20,
        intCurrent:1,
        errQusts:[],
        plateId:"",
        searchType:"",
        paperSubs:[],
        searchWords:"",
        searchSub:""
    };
  },

  components: {},

  computed: {
      
  },
  watch:{
      searchType(newVal){
          if(newVal)
          {
              this.toPage(0);
          }
      }
  },
  mounted() {
    this.$axios.get(`/api/questionFormalInfos?page=1&limit=6&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.errQusts=res.data.data;
            this.intTotal = res.data.total;
        }
    });
  },

  methods: {
      toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
      },
      setSearchSubs(searchSub){
          this.searchSub = searchSub;
      },
      toPage(intcount){
        if(intcount)this.intCurrent = intcount;
       
        this.$axios.get(`/api/questionFormalInfos?page=${this.intCurrent}&limit=6&sort=-createdAt`).then((res) => {
            if (res.data) {
                this.errQusts=res.data.data;
                 this.toTop();
            }
        });
      },
      getQustInfo(errQust){
        switch(errQust.questiontype)
        {
            case "判断题": 
                return errQust.examJudgementQuestion;
            case "单选题": 
                return errQust.examSingleSelection;
            case "多选题":
                return errQust.examMultipleSelection;
            case "填空题":
                return errQust.examCompletQuestion;
            case "复合题":
                return errQust.examCompoundQuestion;
            case "问答题":
                return errQust.examLargeQuestion;
        }
      },
      getTimediff(starttime, endtime){
            console.log(starttime)
            let start = new Date(starttime);
            let end = new Date(endtime);
            let time = end - start;
            console.log(time);
            //计算出相差天数
            var days=Math.floor(time/(24*3600*1000))
            
            //计算出小时数

            var leave1=time%(24*3600*1000)    //计算天数后剩余的毫秒数
            var hours=Math.floor(leave1/(3600*1000))
            //计算相差分钟数
            var leave2=leave1%(3600*1000)        //计算小时数后剩余的毫秒数
            var minutes=Math.floor(leave2/(60*1000))
            //计算相差秒数
            var leave3=leave2%(60*1000)      //计算分钟数后剩余的毫秒数
            var seconds=Math.round(leave3/1000)
            return `${('00'+hours).slice(-2)}:${('00'+minutes).slice(-2)}:${('00'+seconds).slice(-2)}`
        },
      dateFormat(date, format){
            var o = {
            "M+" : date.getMonth()+1, //month
            "d+" : date.getDate(), //day
            "h+" : date.getHours(), //hour 24
            "H+" : date.getHours(), //hour 24
            "m+" : date.getMinutes(), //minute
            "s+" : date.getSeconds(), //second
            "q+" : Math.floor((date.getMonth()+3)/3), //quarter
            "S" : date.getMilliseconds() //millisecond
            };

            if(/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
            }

            for(var k in o) {
                if(new RegExp("("+ k +")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
                }
            }
            return format;
        },
         NewDate(str){ 
            if(!str){
                return 0;
            }
            let arr=str.split(" ");
            let d=arr[0].split("-");
            let t=arr[1].split(":");
            var date = new Date();
            date.setUTCFullYear(d[0], d[1] - 1, d[2]);
            date.setUTCHours(t[0], t[1], t[2], 0);
            return date;
        },
       
  }
}

</script>
<style scoped>

.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}

.course-wrapper{
	width: 1198px;
	height: 93px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}
.course-item{
    width: 1198px;
	min-height: 292px;
    margin-bottom:40px;
}
.course-content{
    width: 1198px;
	min-height: 292px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}
</style>